export default "<div class=\"lds-ellipsis\">\n  <div></div>\n  <div></div>\n  <div></div>\n  <div></div>\n</div>"